import * as _ from 'lodash'
import React, { useState } from 'react';
import util from '../util';
import validator from '../validator';
import valueFilters from '../valueFilters';
import enums from '../enum';
import * as actions from '../actions';
import * as employeeActions from '../employeeActions';
import globalRelay from '../globalRelay';
import componentServices from '../componentServices';
import { useSaveRoot } from '../saveRoot';
import employeeModel, { IEmployee } from '../models/employeeModel';
import { Alert, AsyncButton, AuthorizedContent, Avatar, Confirm, Lockable, PercentInput, PhoneInput, Radio } from './sharedComponents';
import store, { getModel, ModelCollection } from '../store';
import employeeFactory from '../models/employeeModel';

class ModuleRow extends React.Component<any,any> {
	constructor (props) {
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.handlePrimaryClick = this.handlePrimaryClick.bind(this);
	}

	handleChange (newButton, oldButton) {
		if (newButton.value !== oldButton.value) {
			this.props.onChange(newButton.value, this.props.module, this.props.feature);
		}
	}

	handlePrimaryClick (e) {
		e.preventDefault();
		if (!this.props.isPrimary) {
			this.props.onPrimaryChange(this.props.module.key);
		}
	}

	render () {
		const { enabled, module, isPrimary } = this.props;
		const buttons = [
			{ classNames: ['icon yes'], isSelected: enabled, value: true },
			{ classNames: ['icon no'], isSelected: !enabled, value: false }
		];
		const rowClass = enabled ? 'on' : '';
		const primaryButton = (isPrimary) ? <button className="badge"><span>Primary Mode</span></button> : <button className="labelOnly" onClick={this.handlePrimaryClick}><span>Set as Primary Mode</span></button>;

		return (
			<tr className={rowClass}>
				<td />
				<td>
					<Radio buttons={buttons} onChange={this.handleChange} />
				</td>
				<td>{module.name}</td>
				<td>{primaryButton}</td>
				<td />
			</tr>
		);
	}
}

const ModuleEditor = ({ modules, employee, onChange, ...childProps }) => {
	const user = employee.user;
	const rows: JSX.Element[] = [];

	_.forEach(modules, function (module) {
		const moduleEnabled = user.hasModule(module.key);
		const isPrimary = user.isPrimaryModule(module.key);
		const key = module.key;

		rows.push(<ModuleRow { ...childProps } module={module} enabled={moduleEnabled} isPrimary={isPrimary} onChange={onChange} key={key} />);
		if (!!module.features && module.features.length > 0) {
			const featureStates = module.features.map(function (f) {
				return _.assign({}, f, { enabled: user.hasFeature(module.key, f.key) });
			});
			const rowKey = module.key + '.features';

			rows.push(
				<tr key={rowKey}>
					<td />
					<td />
					<td>
						<FeatureEditor featureStates={featureStates} module={module} onChange={onChange} disabled={!user.hasModule(module.key)} {...childProps} />
					</td>
					<td />
					<td />
				</tr>
			);
		}
	});

	return (<table className="checklist" cellPadding="0" cellSpacing="0">
		<tbody>
			{rows}
		</tbody>
	</table>);
};

class FeatureRow extends React.Component<any,any> {
	constructor (props) {
		super(props);

		this.handleChange = this.handleChange.bind(this);
	}

	handleChange (newButton, oldButton) {
		if (newButton.value !== oldButton.value) {
			this.props.onChange(newButton.value, this.props.module, this.props.feature);
		}
	}

	render () {
		const { enabled, feature } = this.props;
		const buttons = [
			{ classNames: ['icon yes'], isSelected: enabled, value: true },
			{ classNames: ['icon no'], isSelected: !enabled, value: false }
		];
		const rowClass = enabled ? 'on' : '';

		return (
			<tr className={rowClass}>
				<td />
				<td>
					<Radio buttons={buttons} onChange={this.handleChange} />
				</td>
				<td>{ feature.name }</td>
				<td />
				<td />
			</tr>
		);
	}
}

const FeatureEditor = ({ featureStates, ...childProps }) => {
	const rows: JSX.Element[] = [];

	_.forEach(featureStates, function (feature) {
		rows.push(<FeatureRow {...childProps} feature={feature} enabled={feature.enabled} key={feature.key} />);
	});

	return (<table className="checklist" cellPadding="0" cellSpacing="0">
		<tbody>
			{rows}
		</tbody>
	</table>);
};

function ChangePasswordModal({ employeeKey }: { employeeKey: string}) { 
	const [currentPassword, setCurrentPassword] = useState('');
	const [newPassword, setNewPassword] = useState('');
	const alerts = [];
	
	componentServices.store.getIn(['viewState', 'alerts']).forEach(function (def) {
		alerts.push(<Alert type={def.type} message={def.message} isCloseable={def.isCloseable} clear={def.clear} key={def.key} />);
	});

	const alertContainer = alerts.length === 0 ? null : (<div className="alerts">{ alerts }</div>);

	const onChange = (event, name) => {
		switch(name) {
		case 'currentPassword' :
			setCurrentPassword(event.target.value);
			break;
		case 'newPassword' :
			setNewPassword(event.target.value);
			break;
		}
	}
	const handleSave = async () => {
		const employee = getModel({ collection: ModelCollection.employees, key: employeeKey });
		const mutatedEmployee = employeeModel(employee.toDocument());

		mutatedEmployee.user.currentPassword = currentPassword;
		mutatedEmployee.user.password = newPassword;

		await employeeActions.saveEmployee({ employee: mutatedEmployee.toDocument(), patch: mutatedEmployee.getPatch(employee)});

		const alerts = store().getIn(['viewState', 'alerts']);
		if(!alerts.size) {
			actions.popModal();
		}
	}

	const handleClose = () => {
		actions.clearAlerts(); 
		actions.popModal();
	}
	
	const disableEntry = (currentPassword === '' || newPassword === '' ) ? 'disabled' : '';
	return (
		<div className="alert">
			<section>
				<header><span>Change Password</span></header>
				{ alertContainer }
				<div className="content">
					<input type="password" name="currentPassword" placeholder="Enter current password" autoCapitalize="" 
						autoCorrect="off" value={currentPassword} onChange={(e) => onChange(e, 'currentPassword')}>
					</input>
					<input type="password" name={"newPassword"} placeholder="Enter new password" autoCapitalize="" 
						autoCorrect="off" value={newPassword} onChange={(e) => onChange(e, 'newPassword')}></input>
					<div className="actions">
						<button onClick={ handleClose }><span>Cancel</span></button>
						<AsyncButton className="action" asyncAction={ handleSave } disabled={!!disableEntry} label="Save" />
					</div>
				</div>
			</section>
		</div>
	);
	
}

export default function EmployeeEdit() {
	const [otherPhoneType, setOtherPhoneType] = useState(enums.phoneNumberTypes.Mobile);
	const employeeKey = componentServices.routeParams.employeekey;
	const [saveRoot] = useSaveRoot<IEmployee>({
		autoSave:  true,
		globalSave: true,
		warnOnLeave: true,
		stateId: `EmployeeEdit-${employeeKey}`,
		modelFactory: employeeFactory,
		resolveMutableModel(current:IEmployee) {
			const { store } = componentServices;
			const storeModel = (employeeKey === 'new') ? null : getModel({ store, collection: ModelCollection.employees, key: employeeKey });
			let employee = current;
			let rebase = false;

			if (storeModel) {
				if (!employee || storeModel.key !== employee.key) {
					employee = employeeModel(storeModel.toDocument());
				}
				else if (storeModel.key === employee.key && storeModel.itemVersion !== employee.itemVersion) {
					employee = employeeModel(storeModel.toDocument());
					rebase = true;
				}
			}
			else if (!saveRoot.model) {
				// new employee
				employee = employeeModel({ key: employeeKey });
			}

			return [employee, rebase];
		},
		save: (doc, patch) => employeeActions.saveEmployee({ employee: doc, patch }),
		validate(model) {
			const messages = validator.test(model, _.omit(employeeFactory.rules(), ['user'])) || [];

			model.user.test('userName', messages);

			return messages;
		}

	})

	function remove () {
		const deleter = () => {
			employeeActions.deleteEmployee({ key: saveRoot.model.key });
			actions.popModal();

			componentServices.router.replaceHistory('/system-admin');
		};

		actions.pushModal({
			component: <Confirm title="Delete Employee?" message="Are you sure you want to permanently delete this user?" confirmLabel="Yes" cancelLabel="No" cancelHandler={ actions.popModal } confirmHandler={ deleter } />
		});
	}

	function updateOtherPhoneType (e) {
		e.preventDefault();
		const newVal = Number(e.target.value);

		setOtherPhoneType(newVal);
	}

	function handlePhoneUpdate (phoneType, autoSave, e) {
		const viewValue = e.target.value;

		saveRoot.update((model) => {
			model.setPhoneNumber(phoneType, viewValue);
		}, { autoSave: autoSave });
	}

	function updateActive (newButton) {
		updateModelAt('inactive', true, newButton.value);
	}

	function updateAvatar (dataUrl) {
		updateModelAt('avatarUrl', true, dataUrl);
	}

	function _setPrimaryModule (user, moduleKey) {
		user.primaryModule = moduleKey;
		if (!user.hasModule(user.primaryModule)) {
			user.setClaim(user.primaryModule + '-*', true);
		}
	}

	function updatePrimaryModule (moduleKey) {
		saveRoot.update((model) => {
			const user = model.user;

			_setPrimaryModule(user, moduleKey);
		}, { autoSave: true });
	}

	function updateModules (enable, module, feature) {
		saveRoot.update((model) => {
			const user = model.user;
			const initialClaimCount = user.claims.length();
			const claim = module.key + ((feature) ? '-' + feature.key : '-*');

			if (!feature) {
				user.setClaim(claim, enable);
			}
			else {
				const wildcard = module.key + '-*';
				let enabledCount = 0;
				const featureStates = module.features.map(function (f) {
					return { key: f.key, wasEnabled: user.hasFeature(module.key, f.key) };
				});

				// clear the wildcard to reset this module's permissions and then reassess after the feature is updated
				user.setClaim(wildcard, false);
				user.setClaim(claim, enable);

				_.forEach(featureStates, function (f) {
					let enabled = false;

					if (f.key === feature.key) {
						enabled = user.hasFeature(module.key, f.key, true);
					}
					else {
						enabled = f.wasEnabled;
						user.setClaim(module.key + '-' + f.key, enabled);
					}
					if (enabled) { enabledCount++; }
				});

				if (enabledCount === featureStates.length) { user.setClaim(wildcard, true); }
			}

			// check to see if our primary module is still valid
			if (!!user.primaryModule && !user.hasModule(user.primaryModule)) {
				user.primaryModule = '';
			}

			if (initialClaimCount === 0 && user.claims.length() > 0) {
				_setPrimaryModule(user, module.key);
			}
		}, { autoSave: true });
	}

	function updateProfileValue (key, autoSave, e) {
		const newVal = autoSave ? valueFilters.clean(e.target.value) : e.target.value;

		saveRoot.update((model) => {
			model.setProfileValue(key, newVal);
		}, { autoSave: autoSave });
	}

	function updateModelAt (path, autoSave, newVal) {
		saveRoot.update((model) => {
			model.setAt(path, newVal);
		}, { autoSave: autoSave });
	}

	function updateModel (path, autoSave, e) {
		e.preventDefault();

		const newVal = e.target.value;

		updateModelAt(path, autoSave, newVal);
	}

	function resendInvitation (e) {
		e.preventDefault();
		const sendNotification = () => {
			employeeActions.sendInvitation({ key: saveRoot.model.key })
			actions.popModal();
		}

		actions.pushModal({
			component: <Confirm cancelHandler={ actions.popModal } confirmHandler={ sendNotification } title="Resend Notification" message="This will reset the user's password and send a new invitation email. Would you like to proceed?" />
		});
	}

	function showPasswordModal () {
		return actions.pushModal({
			component: <ChangePasswordModal employeeKey={ saveRoot.model?.key } />,
			rendersAlerts: true
		});
	}

	// const { saveRoot, ...childProps } = this.props;

	const employee = saveRoot.model;
	let variantRow;

	if (!employee) { return null; }

	const globalConfig = globalRelay.config!;
	const roleTitleTests = globalConfig.systemRoleEmployeeTitleTests;
	const designerTests = roleTitleTests.designer;
	const isSelf = componentServices.securityContext.isCurrentEmployee(employee.key);
	const isProfileOnlyEdit = isSelf && !componentServices.securityContext.currentUserHasModule('system-admin');
	const isDesigner = _.reduce(designerTests, (r, v) => {
		if (!r) {
			const test = new RegExp(v, 'i');
			r = test.test(employee.orgTitleKey);
		}
		return r;
	}, false);

	const commissionRow = isDesigner ? (<tr>
		<td />
		<td><strong>Sales Commission %</strong></td>
		<td>
			<PercentInput value={ employee.viewValue('salesCommissionPercent') } onChange={ updateModel.bind(null, 'salesCommissionPercent', false) } onBlur={ updateModel.bind(null, 'salesCommissionPercent', true) } />
		</td>
		<td />
	</tr>) : null;

	if (globalConfig.variants.length > 1) {
		const variantOptions = _.map(globalConfig.variants, v => <option key={ v.variant } value={ v.variant }>{ v.companyName }</option>);
		variantRow = (<tr>
			<td />
			<td><strong>Default Variant</strong></td>
			<td><select className="select" value={ util.reactVal(employee.getProfileValue('defaultCompanyVariant')) } onChange={ updateProfileValue.bind(null, 'defaultCompanyVariant', true) }>{ variantOptions }</select></td>
			<td />
		</tr>);
	}

	const domainEntities = componentServices.store.getIn(['model', 'domainEntities']);
	const modules = domainEntities.modules;

	const activeButtons = [
		{ classNames: [], isSelected: !employee.inactive, label: 'Active', value: false },
		{ classNames: [], isSelected: !!employee.inactive, label: 'Inactive', value: true }
	];
	const otherPhoneOptions = [
		<option value={enums.phoneNumberTypes.Mobile} key="mobilePhoneOption">Mobile Phone</option>,
		<option value={enums.phoneNumberTypes.Home} key="homePhoneOption">Home Phone</option>
	];
	const orgTitleOptions = _.map(domainEntities.orgTitles, t => {
		return (<option value={t.key} key={t.key}>{t.name}</option>);
	});

	orgTitleOptions.unshift(<option value={undefined} key="none" />);

	const orgDeptOptions = _.map(domainEntities.orgDepartments, d => {
		return (<option value={d.key} key={d.key}>{d.name}</option>);
	});

	orgDeptOptions.unshift(<option value={undefined} key="none" />);

	const otherPhone = employee.getPhoneNumberByType(otherPhoneType);
	const otherPhoneNumber = otherPhone ? otherPhone.number : '';

	return (
		<React.Fragment>
			<section className="systemAdmin">
				<section>
					<AuthorizedContent isAuthorized={({ securityContext }) => securityContext.currentUserHasModule('system-admin')}>
						<header>
							<div className="actions">
								{ employee.isValid()? <button onClick={resendInvitation}><span>Resend Invitation</span></button>: null }
							</div>
							<span>OVERVIEW</span>
						</header>
					</AuthorizedContent>
					<div>
						<table className="half" cellPadding="0" cellSpacing="0">
							<tbody>
								<tr className={!employee.isValid('firstName') ? 'required' : ''}>
									<td />
									<td><strong>First Name</strong></td>
									<td><Lockable isLocked={isProfileOnlyEdit}><input type="text" className="" placeholder="First Name" autoCapitalize="" autoCorrect="off" value={employee.viewValue('firstName')} onChange={updateModel.bind(null, 'firstName', false)} onBlur={updateModel.bind(null, 'firstName', true)} /></Lockable></td>
									<td />
								</tr>
									
								<tr className={!employee.isValid('lastName') ? 'required' : ''}>
									<td />
									<td><strong>Last Name</strong></td>
									<td><Lockable isLocked={isProfileOnlyEdit}><input type="text" placeholder="Last Name" autoCapitalize="" autoCorrect="off" value={employee.viewValue('lastName')} onChange={updateModel.bind(null, 'lastName', false)} onBlur={updateModel.bind(null, 'lastName', true)} /></Lockable></td>
									<td />
								</tr>
									
								<tr className={!employee.user.isValid('userName') ? 'required' : ''}>
									<td />
									<td><strong>Username</strong></td>
									<td><Lockable isLocked={isProfileOnlyEdit}><input type="text" placeholder="Username" autoCapitalize="" autoCorrect="off" value={employee.user.viewValue('userName')} onChange={updateModel.bind(null, '/user/userName', false)} onBlur={updateModel.bind(null, '/user/userName', true)}/></Lockable></td>
									<td />
								</tr>

								{ isSelf ?
									<tr className="">
										<td></td>
										<td><strong>Password</strong></td>
										<td><span className="readOnly"><a onClick={showPasswordModal}>Change Password</a></span></td>
										<td></td>
									</tr> : null
								}

								<tr>
									<td />
									<td><strong>Job Title</strong></td>
									<td>
										<Lockable isLocked={isProfileOnlyEdit}>
											<select value={employee.viewValue('orgTitleKey')} onChange={updateModel.bind(null, 'orgTitleKey', true)}>
												{orgTitleOptions}
											</select>
										</Lockable>
									</td>
									<td />
								</tr>
								<tr>
									<td />
									<td><strong>Department</strong></td>
									<td>
										<Lockable isLocked={isProfileOnlyEdit}>
											<select value={employee.viewValue('orgDepartmentKey')} onChange={updateModel.bind(null, 'orgDepartmentKey', true)}>
												{orgDeptOptions}
											</select>
										</Lockable>
									</td>
									<td />
								</tr>
							</tbody>
						</table>
						<table className="half" cellPadding="0" cellSpacing="0">
							<tbody>
								<tr className={!employee.isValid('avatarUrl') ? 'required' : ''}>
									<td />
									<td><strong>Profile Photo</strong></td>
									<td>
										<Avatar className="userPhotoControl" imageWidth={80} imageHeight={80} onImage={ updateAvatar } imageUrl={employee.avatarUrl} canEdit={true} />
										{!employee.avatarUrl ? null : <a onClick={() => updateAvatar(null)}>Remove</a>}
									</td>
									<td />
								</tr>
								<tr className={!employee.isValid('emailAddress') ? 'required' : ''}>
									<td />
									<td><strong>Email Address</strong></td>
									<td><input type="text" placeholder="Email Address" autoCapitalize="" autoCorrect="off" value={employee.viewValue('emailAddress')} onChange={updateModel.bind(null, 'emailAddress', false)} onBlur={updateModel.bind(null, 'emailAddress', true)} /></td>
									<td />
								</tr>
								<tr className={(!!employee.workPhoneNumber && !validator.isPhone(employee.workPhoneNumber)) ? 'required' : ''} >
									<td />
									<td><strong>Office Phone</strong></td>
									<td><PhoneInput placeholder="" autoCapitalize="" autoCorrect="off" value={ employee.viewValue('workPhoneNumber') } onChange={handlePhoneUpdate.bind(null, enums.phoneNumberTypes.Work, false)} onBlur={handlePhoneUpdate.bind(null, enums.phoneNumberTypes.Work, true)} /></td>
									<td />
								</tr>
								<tr className={(!!otherPhone && !validator.isPhone(otherPhoneNumber)) ? 'required' : ''}>
									<td />
									<td>
										<select className="label" value={util.reactVal(otherPhoneType)} onChange={updateOtherPhoneType}>
											{otherPhoneOptions}
										</select>
									</td>
									<td><PhoneInput placeholder="" autoCapitalize="" autoCorrect="off" value={ otherPhoneNumber } onChange={handlePhoneUpdate.bind(null, otherPhoneType, false)} onBlur={handlePhoneUpdate.bind(null, otherPhoneType, true)} /></td>
									<td />
								</tr>
								<AuthorizedContent isAuthorized={({ securityContext }) => securityContext.currentUserHasModule('system-admin')}>{ commissionRow }</AuthorizedContent>
								<AuthorizedContent isAuthorized={({ securityContext }) => securityContext.currentUserHasModule('system-admin')}>{ variantRow }</AuthorizedContent>
							</tbody>
						</table>
					</div>
				</section>
				<AuthorizedContent isAuthorized={({ securityContext }) => securityContext.currentUserHasModule('system-admin')}>
					<section>
						<header>
							<div className="actions">
								<Radio buttons={activeButtons} onChange={updateActive} />
							</div>
							<span>MODULES <span>Select at least one</span></span>
						</header>
						<div>
							<ModuleEditor modules={modules} employee={employee} onChange={updateModules} onPrimaryChange={updatePrimaryModule} />
						</div>
					</section>
				</AuthorizedContent>
			</section>
			<AuthorizedContent isAuthorized={({ securityContext }) => securityContext.currentUserHasModule('system-admin')}>
				<footer><div className="actions"><button className="labelOnly deleteItem" onClick={remove}>Permanently Delete this Person</button></div></footer>
			</AuthorizedContent>
		</React.Fragment>
	);
}
